<template>
  <div class="vehicleActivity" v-if="sendData && sendData.length">
    <ul>
      <li v-for="item in sendData" :key="item.OfferID">
        <div class="productItem">
          <img :src="item.LinkUrl" alt="大方租车" @click="goProductInfo(item.OfferID)">
          <div class="showAlert" @click="showRuleAlert=false"></div>
          <div class="priceBox">
            <span>￥</span><strong>{{ item.LeastPrice }}</strong><span>/日起</span>
          </div>
        </div>
      </li>
    </ul>
    <!-- 弹出层 -->
    <div class="ruleAlert" v-if="showRuleAlert">
      <div class="adds_mask" @click="showRuleAlert=false"></div>
      <div class="box">
        <div class="content">
          <div class="title"></div>
          <div class="item">品质严选是大方租车精选出的最优车型，为您提供3年内新车、一车一洗、按时保养、免费救援4大服务保障。</div>
        </div>
        <div class="button" @click="showRuleAlert=false">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { resourceUrl, orderSource, mySelfURL } from "@/utils/env";
  import { getProductListOffer } from "@/utils/api";
  export default {
    name: 'productTop',
    data(){
      return {
        resourceUrl: resourceUrl,
        orderSource: orderSource,
        showRuleAlert: false
      }
    },
    props: {
      queryId: { default: '' },
      sendData: { default: null }
    },
    created () {},
    mounted () {
      // this.initData();
    },
    methods: {
      goProductInfo (id) {
        // this.$router.replace({ name: "vehicleActivityInfo", query: { id: id } });
        if( orderSource==16 ){
          let baseUrl = mySelfURL + `/vehicleActivityInfo?id=${id}`;
          dfpanda.openPage(JSON.stringify({type: 'html', url: baseUrl}));
        } else if( orderSource==17 ) {
          let baseUrl = mySelfURL + `/vehicleActivityInfo?id=${id}`;
          window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: 'html', url: baseUrl}));
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .vehicleActivity {
    padding-top: 20px;
    padding-bottom: 50px;
    .productItem {
      width: 684px;
      margin: 0 auto 30px;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
      position: relative;
      img { width: 100%; }
      .showAlert {
        width: 100%;
        height: 40px;
        /*background-color: red;*/
        background-color: transparent;
        opacity: 0.2;
        position: absolute;
        left: 0;
        bottom: 44px;
      }
      .priceBox {
        width: 136px;
        height: 50px;
        line-height: 50px;
        position: absolute;
        right: 34px;
        top: 42px;
        color: #fff;
        text-align: center;
        span { font-size: 14px; }
        strong {
          font-size: 32px;
          font-weight: normal;
        }
      }
    }
    /* 弹出层 */
    .ruleAlert{
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      .adds_mask{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: #000;
        opacity: 0.7;
        z-index: 99;
      }
      .box{
        position: absolute;
        top: 390px;
        left: 8%;
        z-index: 1000;
        width: 84%;
        background-color: #fff;
        .content{
          padding: 30px;
          box-sizing: border-box;
          .item{
            width: 100%;
            margin-top: 20px;
            line-height: 42px;
            color: #5E5E5E;
            font-size: 25px;
          }
          .title{
            display: flex;
            width: 100%;
            height: 90px;
            justify-content: center;
            background: url("~@/assets/images/car/pinzhi.png") no-repeat center;
            background-size: contain;
          }
        }
        .button{
          display: flex;
          justify-content: center;
          padding: 30px 0;
          font-size: 32px;
          color: #ff6600;
          border-top: solid 1px #e2e2e2;
        }
      }
    }
  }
</style>